/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllPublishedRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc',
  rpcName: 'getAllPublished',
  auth: 'external',
  fingerprint: 'J6TmYWMlkCrRjtGx5d1plZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRelevantPublishedCalloutIdsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.FeaturedCalloutsPublicRpc',
  rpcName: 'getRelevantPublishedCalloutIds',
  auth: 'external',
  fingerprint: 'QbMD5w9TzU7Pj0w4QIAs6JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};